import { createContext, useContext, useEffect, useRef, useState } from "react";
import socketIO from "socket.io-client";
import { useAuth } from "../Auth/AuthWrapper";

const SocketContext = createContext();
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
const SOCKET_PATH =
  process.env.REACT_APP_SOCKET_PATH &&
  process.env.REACT_APP_SOCKET_PATH.trim() !== "" &&
  process.env.REACT_APP_SOCKET_PATH.trim() !== "''"
    ? process.env.REACT_APP_SOCKET_PATH.trim()
    : "/socket.io";

const createSocketConnection = () => {
  const connection = socketIO.connect(SOCKET_URL, {
    path: SOCKET_PATH,
    transports: ["websocket"],
  });

  connection.on("connect", () => {
    // console.log("[socket.io] connected", {
    //   id: connection.id,
    //   url: SOCKET_URL,
    //   path: SOCKET_PATH,
    // });
  });

  connection.on("connect_error", (error) => {
    // console.error("[socket.io] connect_error", {
    //   message: error?.message,
    //   url: SOCKET_URL,
    //   path: SOCKET_PATH,
    // });
  });

  connection.on("disconnect", (reason) => {
    // console.warn("[socket.io] disconnected", {
    //   reason,
    //   url: SOCKET_URL,
    //   path: SOCKET_PATH,
    // });
  });

  return connection;
};

export const SocketWrapper = ({ children }) => {
  const socketRef = useRef();
  const auth = useAuth();
  const [isConnected, setIsConnected] = useState(false);

  const loginSocket = async (data) => {
    if (!socketRef.current) {
      socketRef.current = createSocketConnection();
    }
  };

  const logoutSocket = async () => {
    if (socketRef.current) {
      socketRef.current.emit("forceDisconnect");
    }
  };

  useEffect(() => {
    if (!socketRef.current && auth.user.role != "User") {
      socketRef.current = createSocketConnection();
    }

    const currentSocket = socketRef.current;
    if (currentSocket) {
      const handleConnect = () => setIsConnected(true);
      const handleDisconnect = () => setIsConnected(false);
      const handleConnectError = () => setIsConnected(false);

      currentSocket.on("connect", handleConnect);
      currentSocket.on("disconnect", handleDisconnect);
      currentSocket.on("connect_error", handleConnectError);
      setIsConnected(currentSocket.connected);

      return () => {
        currentSocket.off("connect", handleConnect);
        currentSocket.off("disconnect", handleDisconnect);
        currentSocket.off("connect_error", handleConnectError);

        // Clean up socket connection on unmount
        if (socketRef.current) {
          socketRef.current.disconnect();
          setIsConnected(false);
          socketRef.current = null;
        }
      };
    }

    return undefined;
  }, [auth.user]);
  // }, [socketRef.current]);

  return (
    <SocketContext.Provider
      value={{ socket: socketRef, loginSocket, logoutSocket, isConnected }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  return useContext(SocketContext);
};
